import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';
import AutosuggestField from 'components/fields/AutosuggestField';
import CheckboxField from 'components/fields/CheckboxField';

import {
  createNoteCategory,
  updateNoteCategory,
} from 'redux/modules/noteCategories';

import {
  requestFetchWorkflowStates,
  requestSearchWorkflowStates,
} from 'redux/modules/workflowStates';

import { accountLoginFail } from 'redux/modules/account';

import * as validate from 'utils/validate';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues, {});
    if (normalizedValues['Workflow State Name'] === '') {
      normalizedValues['Workflow State ID'] = null;
    }
    delete normalizedValues['Workflow State Name'];
    delete normalizedValues['Selected Workflow State Name'];
    
    return normalizedValues;
  };
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = normalizeValues(objectDiff(values, props.initialValues));
    return new Promise((resolve, reject) => {
      dispatch(updateNoteCategory({
        values: {
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
          ? 'Sorry, but such Note Category already exists' : err.error });
      });
  }

  return new Promise((resolve, reject) => {
    dispatch(createNoteCategory({
      values: normalizeValues({
        ...values,
        ...!values['Is Delivery'] ? {
          'Is Delivery': false,
        } : {},
      }),
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
        ? 'Sorry, but such Note Category already exists' : err.error });
    });
}

const NoteCategoryCreateEditForm = ({
  handleSubmit,
  className,
  error,
  change,
  actions,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Name"
          name="Name"
          label="Name"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Workflow State Name"
          name="Workflow State Name"
          label="Workflow Category"
          component={AutosuggestField}
          errorPlacement="top"
          fullWidth
          renderSuggestionContent={suggestion => suggestion.Name}
          onSuggestionSelected={(suggestion) => {
            change('Workflow State ID', suggestion.ID);
            change('Selected Workflow State Name', suggestion.Name);
            return suggestion.Name;
          }}
          fetchSuggestions={({ value, limit, offset }) => (
            value.length > 0
              ? requestSearchWorkflowStates({
                filters: [
                  {
                    name: 'Name',
                    operation: 'contains',
                    val: value,
                    case_sensitivity: false,
                  },
                ],
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
              : requestFetchWorkflowStates({
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
          )}
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item>
        <Field
          id="Is Active"
          name="Is Active"
          label="Active"
          component={CheckboxField}
        />
      </Grid>
      <Grid item>
        <Field
          id="Is Delivery"
          name="Is Delivery"
          label="Printed in Delivery Instructions"
          component={CheckboxField}
        />
      </Grid>
    </Grid>
  </form>
);

NoteCategoryCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

NoteCategoryCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'noteCategoryCreate',
  onSubmit,
})(withStyles(styles)(NoteCategoryCreateEditForm)));



// WEBPACK FOOTER //
// ./src/components/settings/NoteCategoryCreateEditDialog/NoteCategoryCreateEditForm.js